// Verfuegbarkeit der Honigsorten aus einer veroeffentlichten Google-Tabelle.
//
// Warum so: Die Website ist statisch (Amplify-Hosting, kein Backend). Damit
// die Imkerei die Verfuegbarkeit ohne Deploy umstellen kann, liegt sie in
// einer Google-Tabelle, die zur Laufzeit gelesen wird. Die Zugriffskontrolle
// macht Google ueber die Freigabe der Tabelle — im Frontend steht daher
// bewusst kein Passwort.
//
// Erwartete Spalten (Kopfzeile, Reihenfolge egal):
//   id | sorte | groesse | verfuegbar
// Technisch zaehlt nur "id" (die ID aus products.json) und "verfuegbar"
// ("ja" oder "nein"). Die uebrigen Spalten sind Lesehilfe fuer die Person,
// welche die Tabelle pflegt.
//
// Faellt die Tabelle aus oder ist ein Wert unlesbar, gilt weiterhin der Wert
// aus products.json. Der Shop laeuft also auch dann korrekt weiter.

// Veroeffentlichte Google-Tabelle (Datei > Freigeben > Im Web veroeffentlichen,
// Format CSV). Die Adresse leitet auf googleusercontent.com weiter; beide
// Sprunge senden die noetigen CORS-Header, der Browser darf also direkt laden.
export const AVAILABILITY_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vRE3F8nB_za5LwVOqbNF7Xce9uFcq70mjbviphOAYF5EoWruWQcSD8hI5Qs7gr_wylBHjOWfMMM7mfQ/pub?gid=0&single=true&output=csv";

const SOLD_OUT = "ausverkauft";
const IN_STOCK = "verfügbar";

const TRUE_VALUES = ["ja", "j", "yes", "y", "x", "true", "wahr", "1", "verfügbar", "verfuegbar"];
const FALSE_VALUES = ["nein", "n", "no", "false", "falsch", "0", "ausverkauft"];

// Minimaler CSV-Parser: beherrscht Anfuehrungszeichen und doppelte
// Anfuehrungszeichen als Escape, mehr braucht dieses Format nicht.
export function parseCsv(text) {
  const rows = [];
  let row = [];
  let field = "";
  let quoted = false;

  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (quoted) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i++; }
        else quoted = false;
      } else field += c;
      continue;
    }
    if (c === '"') { quoted = true; }
    else if (c === ",") { row.push(field); field = ""; }
    else if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; }
    else if (c !== "\r") { field += c; }
  }
  if (field !== "" || row.length) { row.push(field); rows.push(row); }
  return rows.filter(r => r.some(cell => cell.trim() !== ""));
}

// Ergibt eine Map id -> true/false. Zeilen mit unbekanntem Wert werden
// ausgelassen, damit products.json fuer sie massgebend bleibt.
export function parseAvailabilitySheet(csvText) {
  const rows = parseCsv(csvText);
  if (rows.length < 2) return new Map();

  const header = rows[0].map(h => h.trim().toLowerCase());
  const idCol = header.indexOf("id");
  const availCol = header.findIndex(h => h === "verfuegbar" || h === "verfügbar");
  if (idCol === -1 || availCol === -1) return new Map();

  const result = new Map();
  rows.slice(1).forEach(row => {
    const id = parseInt((row[idCol] || "").trim(), 10);
    if (Number.isNaN(id)) return;
    const raw = (row[availCol] || "").trim().toLowerCase();
    if (TRUE_VALUES.includes(raw)) result.set(id, true);
    else if (FALSE_VALUES.includes(raw)) result.set(id, false);
  });
  return result;
}

// Legt die Tabellenwerte ueber die Kategorien aus products.json.
export function applyAvailability(categories, availabilityById) {
  if (!availabilityById || availabilityById.size === 0) return categories;
  return categories.map(category => ({
    ...category,
    items: (category.items || []).map(item => {
      if (!availabilityById.has(item.id)) return item;
      return {
        ...item,
        availability: availabilityById.get(item.id) ? IN_STOCK : SOLD_OUT,
      };
    }),
  }));
}

export function fetchAvailability() {
  if (!AVAILABILITY_SHEET_URL) return Promise.resolve(new Map());
  return fetch(AVAILABILITY_SHEET_URL)
    .then(res => {
      if (!res.ok) throw new Error("Tabelle antwortet mit " + res.status);
      return res.text();
    })
    .then(parseAvailabilitySheet)
    .catch(err => {
      // Bewusst kein harter Fehler: products.json bleibt massgebend.
      console.warn("Verfügbarkeitstabelle nicht lesbar, nutze products.json:", err.message);
      return new Map();
    });
}
